import { FieldHookConfig, useField } from 'formik';

import { PhoneInput, PhoneInputProps } from '../../../components/PhoneInput';

// Define props for the Formik wrapper
// Omit props handled by Formik AND props hardcoded in the base component
type FormPhoneInputProps = Omit<
  PhoneInputProps,
  | 'value'
  | 'onChange'
  | 'onBlur'
  | 'name'
  | 'error'
  | 'helperText'
  | 'forceCallingCode'
> &
  FieldHookConfig<string>;

export const FormPhoneInput: React.FC<FormPhoneInputProps> = ({ ...props }) => {
  const [field, meta, helpers] = useField(props);
  const { setValue } = helpers;

  // Render the new base PhoneInput component
  return (
    <PhoneInput
      {...props} // Pass through other props (like defaultCountry, etc.)
      name={field.name} // Pass Formik name
      value={field.value || ''} // Pass Formik value
      onBlur={field.onBlur} // Pass Formik onBlur
      error={!!(meta.touched && meta.error)} // Calculate error from meta
      helperText={meta.touched && meta.error ? meta.error : undefined} // Set helperText from meta
      fullWidth
      onChange={(value) => {
        // Update Formik state
        setValue(value);
      }}
    />
  );
};
